import FaxIcon from '@mui/icons-material/Fax';
import HomeIcon from '@mui/icons-material/Home';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import WorkIcon from '@mui/icons-material/Work';

import defaultVcardLogo from '~/assets/images/default-vcard-logo.webp';

export const PHONE_TYPES = [
  // Dymamic uses "MOBILE" but static "CELL"
  { id: 'CELL', Icon: PhoneIphoneIcon, translate: 'template5:phoneType:mobile' },
  { id: 'WORK', Icon: WorkIcon, translate: 'template5:phoneType:work' },
  { id: 'HOME', Icon: HomeIcon, translate: 'template5:phoneType:home' },
  { id: 'FAX', Icon: FaxIcon, translate: 'template5:phoneType:fax' },
  { id: 'OTHER', Icon: LocalPhoneIcon, translate: 'template5:phoneType:other' },
];

export const LOCATION_TYPE = {
  FULL: 'FULL',
  URL: 'URL',
  COORDINATES: 'COORDINATES',
} as const;

export const V_CARD_BUILDER_COLORS = [
  ['#B0B1FF', '#8267E3'],
  ['#F18430', '#FFFFFF'],
  ['#42A5F5', '#1E88E5'],
  ['#EF5350', '#C62828'],
  ['#FF9800', '#EF6C00'],
];

export const DEFAULT_CREATE_V_CARD_PLUS_PAYLOAD = {
  selected_template: 0,
  design: {
    primary: V_CARD_BUILDER_COLORS[0][0],
    secondary: V_CARD_BUILDER_COLORS[0][1],
  },
  fonts: {},
  person: {
    first_name: 'Name',
    last_name: 'Surname',
    title: 'Test title',
    photo: {
      url: defaultVcardLogo,
      scale: 100,
      borderRadius: 50,
      rotate: 0,
    },
  },
  person_title: 'CENTERED',
  summary:
    'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  images_view_type: 'VERTICAL',
  socials_title: 'Find me on:',
  socials: [
    { network: 'INSTAGRAM', url: 'https://www.instagram.com', title: '' },
    { network: 'FACEBOOK', url: 'https://www.facebook.com', title: '' },
    { network: 'GITHUB', url: 'https://github.com', title: '' },
  ],
  contact_storage_option: 'CONTACT_STORAGE_TITLE_ONLY',
  header: {
    header_phone: 'Phone',
    header_location: 'Geo',
    header_email: 'Email',
  },
  footer: 'Add contact',
  contact_add_btn_on_the_top: false,
  contact_add_btn_floating_button: false,
  location: {
    type: 'FULL',
    location_visibility: 'HIDE_ADDRESS_LINK',
    address: '',
    street_number_first: false,
    street: '',
    number: null,
    postal_code: '',
    city: '',
    state: '',
    country: '',
    url: 'https://expl.com',
    latitude: '49.933544',
    longitude: '7.629603',
  },
};

export const DEFAULT_VCARD_COMPANY = {
  position: 0,
  name: 'Company Test',
  profession: 'developer',
};

export const DEFAULT_VCARD_PHONE = {
  type: 'WORK',
  title: 'Phone',
  phone: '+38099112200',
};

export const DEFAULT_VCARD_EMAIL = {
  title: 'Email',
  email: 'example@gmail.com',
};

export const DEFAULT_VCARD_WEBSITE = {
  title: 'Website',
  url: 'https://example.com',
};
